import React, { Fragment } from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import intro29desktop_linha2 from './img/intro29desktop-linha2.png'
import intro29desktop_fill_1 from './img/intro29desktop-fill-1@2x.png'
import intro29desktop_linha1 from './img/intro29desktop-linha1@2x.png'
import intro29desktop_flores from './img/intro29desktop-flores.png'

import intro29mobile_fill_1 from './img/intro29mobile-fill-1@2x.png'
import intro29mobile_fill_3 from './img/intro29mobile-fill-3@2x.png'
import intro29mobile_group_7 from './img/intro29mobile-group-7@2x.png'
import intro29mobile_group_10 from './img/intro29mobile-group-10@2x.png'
import intro29mobile_fill_11 from './img/intro29mobile-fill-11@2x.png'
import intro29mobile_fill_13 from './img/intro29mobile-fill-13@2x.png'
import intro29mobile_fill_15 from './img/intro29mobile-fill-15@2x.png'
import intro29mobile_fill_17 from './img/intro29mobile-fill-17@2x.png'
import intro29mobile_fill_19 from './img/intro29mobile-fill-19@2x.png'
import intro29mobile_fill_21 from './img/intro29mobile-fill-21@2x.png'
import intro29mobile_fill_23 from './img/intro29mobile-fill-23@2x.png'
import intro29mobile_fill_25 from './img/intro29mobile-fill-25@2x.png'
import intro29mobile_fill_27 from './img/intro29mobile-fill-27@2x.png'
import intro29mobile_fill_29 from './img/intro29mobile-fill-29@2x.png'
import intro29mobile_fill_31 from './img/intro29mobile-fill-31@2x.png'
import intro29mobile_fill_33 from './img/intro29mobile-fill-33@2x.png'
import intro29mobile_fill_35 from './img/intro29mobile-fill-35@2x.png'
import intro29mobile_fill_37 from './img/intro29mobile-fill-37@2x.png'
import intro29mobile_fill_39 from './img/intro29mobile-fill-39@2x.png'
import intro29mobile_fill_43 from './img/intro29mobile-fill-43@2x.png'
import intro29mobile_fill_45 from './img/intro29mobile-fill-45@2x.png'
import intro29mobile_fill_49 from './img/intro29mobile-fill-49@2x.png'
import intro29mobile_fill_51 from './img/intro29mobile-fill-51@2x.png'
import intro29mobile_fill_53 from './img/intro29mobile-fill-53@2x.png'
import intro29mobile_fill_55 from './img/intro29mobile-fill-55@2x.png'
import intro29mobile_fill_57 from './img/intro29mobile-fill-57@2x.png'
import intro29mobile_fill_59 from './img/intro29mobile-fill-59@2x.png'
import intro29mobile_fill_61 from './img/intro29mobile-fill-61@2x.png'
import intro29mobile_fill_63 from './img/intro29mobile-fill-63@2x.png'
import intro29mobile_fill_65 from './img/intro29mobile-fill-65@2x.png'
import intro29mobile_fill_67 from './img/intro29mobile-fill-67@2x.png'
import intro29mobile_fill_69 from './img/intro29mobile-fill-69@2x.png'
import intro29mobile_fill_41 from './img/intro29mobile-fill-41@2x.png'
import intro29mobile_fill_73 from './img/intro29mobile-fill-73@2x.png'
import intro29mobile_fill_75 from './img/intro29mobile-fill-75@2x.png'
import intro29mobile_fill_77 from './img/intro29mobile-fill-77@2x.png'
import intro29mobile_fill_79 from './img/intro29mobile-fill-79@2x.png'
import intro29mobile_fill_81 from './img/intro29mobile-fill-81@2x.png'
import intro29mobile_fill_83 from './img/intro29mobile-fill-83@2x.png'
import intro29mobile_fill_85 from './img/intro29mobile-fill-85@2x.png'
import intro29mobile_fill_87 from './img/intro29mobile-fill-87@2x.png'
import intro29mobile_fill_89 from './img/intro29mobile-fill-89@2x.png'
import intro29mobile_fill_91 from './img/intro29mobile-fill-91@2x.png'
import intro29mobile_fill_93 from './img/intro29mobile-fill-93@2x.png'
import intro29mobile_fill_95 from './img/intro29mobile-fill-95@2x.png'
import intro29mobile_fill_97 from './img/intro29mobile-fill-97@2x.png'
import intro29mobile_fill_99 from './img/intro29mobile-fill-99@2x.png'
import intro29mobile_fill_101 from './img/intro29mobile-fill-101@2x.png'
import intro29mobile_fill_103 from './img/intro29mobile-fill-103@2x.png'
import intro29mobile_fill_105 from './img/intro29mobile-fill-105@2x.png'
import intro29mobile_fill_107 from './img/intro29mobile-fill-107@2x.png'
import intro29mobile_fill_109 from './img/intro29mobile-fill-109@2x.png'
import intro29mobile_fill_111 from './img/intro29mobile-fill-111@2x.png'
import intro29mobile_fill_113 from './img/intro29mobile-fill-113@2x.png'
import intro29mobile_flor1 from './img/intro29mobile-flor1@2x.png'
import intro29mobile_linha2 from './img/intro29mobile-linha2@2x.png'
import intro29mobile_fill_1_1 from './img/intro29mobile-fill-1-1@2x.png'
import intro29mobile_linha1 from './img/intro29mobile-linha1@2x.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const day = new Date(weddingDate.timestamp)
    .getDate()
    .toString()
    .padStart(2, '0')
  const month = new Intl.DateTimeFormat(locale, { month: 'long' })
    .format(new Date(weddingDate.timestamp))
    .toUpperCase()
  const year = new Date(weddingDate.timestamp).getFullYear()

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro29">
      <div className="bp1-intro29desktop">
        <div className="bp1-abackground">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="bp1-abackground" />
          )}
        </div>

        <div className="bottom">
          <button className="button" type="button" onClick={onSkipIntro}>
            {buttonMessage}
          </button>
          <p
            className="warning"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
        </div>

        <div className="bp1-bemvindoaonossos-layout-container">
          <div className="bp1-bemvindoaonossos bp1-intro29-anima-animate-enter">
            BEM-VINDO AO NOSSO SITE
          </div>
        </div>
        <div className="bp1-linha2-layout-container">
          <img
            src={intro29desktop_linha2}
            className="bp1-linha2 bp1-intro29-anima-animate-enter1"
          />
        </div>
        <div className="bp1-name-layout-container">
          <div className="bp1-mariana-layout-container">
            <div className="notranslate bp1-mariana bp1-intro29-anima-animate-enter4">
              {coupleSingleName.bride}
            </div>
          </div>
          {!!coupleSingleName.groom && (
            <Fragment>
              <div className="bp1-view1-layout-container">
                <div className="bp1-view1 bp1-intro29-anima-animate-enter3">
                  <img src={intro29desktop_fill_1} className="bp1-fill1" />
                </div>
              </div>
              <div className="bp1-eduardo-layout-container">
                <div className="notranslate bp1-eduardo bp1-intro29-anima-animate-enter2">
                  {coupleSingleName.groom}
                </div>
              </div>
            </Fragment>
          )}
        </div>
        <div className="bp1-data-layout-container">
          <div className="bp1-data">
            <div className="bp1-linha1-layout-container">
              <img
                src={intro29desktop_linha1}
                className="bp1-linha1 bp1-intro29-anima-animate-enter5"
              />
            </div>
            <div className="bp1-a25janeiro204-layout-container">
              <div className="bp1-a25janeiro204 bp1-intro29-anima-animate-enter6">
                {locale === 'en-US' ? (
                  <>
                    <span className="bp1-span1">. </span>
                    <span className="bp1-span3">{month}</span>
                    <span className="bp1-span2"> . {day} . </span>
                    <span className="bp1-span4">{year}</span>
                    <span className="bp1-span5"> .</span>
                  </>
                ) : (
                  <>
                    <span className="bp1-span1">. </span>
                    <span className="bp1-span2">{day}</span>
                    <span className="bp1-span3"> . {month} . </span>
                    <span className="bp1-span4">{year}</span>
                    <span className="bp1-span5"> .</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="bp1-flores-layout-container">
          <img
            src={intro29desktop_flores}
            className="bp1-flores bp1-intro29-anima-animate-enter7"
          />
        </div>
      </div>
      <div className="bp2-intro29mobile">
        <div className="bp2-abackground">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="bp1-abackground" />
          )}
        </div>

        <div className="bottom">
          <button className="button" type="button" onClick={onSkipIntro}>
            {buttonMessage}
          </button>
          <p
            className="warning"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
        </div>

        <div className="bp2-flores-layout-container">
          <div className="bp2-flores">
            <div className="bp2-flor2-layout-container">
              <div className="bp2-flor2 bp2-intro29-anima-animate-enter">
                <img src={intro29mobile_fill_1} className="bp2-fill1" />
                <img src={intro29mobile_fill_3} className="bp2-fill3" />
                <div className="bp2-group7">
                  <img src={intro29mobile_group_7} className="bp2-group71" />
                </div>
                <div className="bp2-group10">
                  <img src={intro29mobile_group_10} className="bp2-group101" />
                </div>
                <img src={intro29mobile_fill_11} className="bp2-fill11" />
                <img src={intro29mobile_fill_13} className="bp2-fill13" />
                <img src={intro29mobile_fill_15} className="bp2-fill15" />
                <img src={intro29mobile_fill_17} className="bp2-fill17" />
                <img src={intro29mobile_fill_19} className="bp2-fill19" />
                <img src={intro29mobile_fill_21} className="bp2-fill21" />
                <img src={intro29mobile_fill_23} className="bp2-fill23" />
                <img src={intro29mobile_fill_25} className="bp2-fill25" />
                <img src={intro29mobile_fill_27} className="bp2-fill27" />
                <img src={intro29mobile_fill_29} className="bp2-fill29" />
                <img src={intro29mobile_fill_31} className="bp2-fill31" />
                <img src={intro29mobile_fill_33} className="bp2-fill33" />
                <img src={intro29mobile_fill_35} className="bp2-fill35" />
                <img src={intro29mobile_fill_37} className="bp2-fill37" />
                <img src={intro29mobile_fill_39} className="bp2-fill39" />
                <img src={intro29mobile_fill_41} className="bp2-fill41" />
                <img src={intro29mobile_fill_43} className="bp2-fill43" />
                <img src={intro29mobile_fill_45} className="bp2-fill45" />
                <img src={intro29mobile_fill_51} className="bp2-fill47" />
                <img src={intro29mobile_fill_49} className="bp2-fill49" />
                <img src={intro29mobile_fill_51} className="bp2-fill51" />
                <img src={intro29mobile_fill_53} className="bp2-fill53" />
                <img src={intro29mobile_fill_55} className="bp2-fill55" />
                <img src={intro29mobile_fill_57} className="bp2-fill57" />
                <img src={intro29mobile_fill_59} className="bp2-fill59" />
                <img src={intro29mobile_fill_61} className="bp2-fill61" />
                <img src={intro29mobile_fill_63} className="bp2-fill63" />
                <img src={intro29mobile_fill_65} className="bp2-fill65" />
                <img src={intro29mobile_fill_67} className="bp2-fill67" />
                <img src={intro29mobile_fill_69} className="bp2-fill69" />
                <img src={intro29mobile_fill_41} className="bp2-fill71" />
                <img src={intro29mobile_fill_73} className="bp2-fill73" />
                <img src={intro29mobile_fill_75} className="bp2-fill75" />
                <img src={intro29mobile_fill_77} className="bp2-fill77" />
                <img src={intro29mobile_fill_79} className="bp2-fill79" />
                <img src={intro29mobile_fill_81} className="bp2-fill81" />
                <img src={intro29mobile_fill_83} className="bp2-fill83" />
                <img src={intro29mobile_fill_85} className="bp2-fill85" />
                <img src={intro29mobile_fill_87} className="bp2-fill87" />
                <img src={intro29mobile_fill_89} className="bp2-fill89" />
                <img src={intro29mobile_fill_91} className="bp2-fill91" />
                <img src={intro29mobile_fill_93} className="bp2-fill93" />
                <img src={intro29mobile_fill_95} className="bp2-fill95" />
                <img src={intro29mobile_fill_97} className="bp2-fill97" />
                <img src={intro29mobile_fill_99} className="bp2-fill99" />
                <img src={intro29mobile_fill_101} className="bp2-fill101" />
                <img src={intro29mobile_fill_103} className="bp2-fill103" />
                <img src={intro29mobile_fill_105} className="bp2-fill105" />
                <img src={intro29mobile_fill_107} className="bp2-fill107" />
                <img src={intro29mobile_fill_109} className="bp2-fill109" />
                <img src={intro29mobile_fill_111} className="bp2-fill111" />
                <img src={intro29mobile_fill_113} className="bp2-fill113" />
              </div>
            </div>
            <div className="bp2-flor1-layout-container">
              <img
                src={intro29mobile_flor1}
                className="bp2-flor1 bp2-intro29-anima-animate-enter1"
              />
            </div>
          </div>
        </div>
        <div className="bp2-bemvindoaonossos-layout-container">
          <div className="bp2-bemvindoaonossos bp2-intro29-anima-animate-enter2">
            BEM-VINDO AO NOSSO SITE
          </div>
        </div>
        <div className="bp2-linha2-layout-container">
          <img
            src={intro29mobile_linha2}
            className="bp2-linha2 bp2-intro29-anima-animate-enter3"
          />
        </div>
        <div className="bp2-name-layout-container">
          <div className="bp2-mariana-layout-container">
            <div className="notranslate bp2-mariana bp2-intro29-anima-animate-enter6">
              {coupleSingleName.bride}
            </div>
          </div>
          {!!coupleSingleName.groom && (
            <Fragment>
              <div className="bp2-view1-layout-container">
                <div className="bp2-view1 bp2-intro29-anima-animate-enter4">
                  <img src={intro29mobile_fill_1_1} className="bp2-fill1" />
                </div>
              </div>
              <div className="bp2-eduardo-layout-container">
                <div className="notranslate bp2-eduardo bp2-intro29-anima-animate-enter5">
                  {coupleSingleName.groom}
                </div>
              </div>
            </Fragment>
          )}
        </div>
        <div className="bp2-data-layout-container">
          <div className="bp2-data">
            <div className="bp2-linha1-layout-container">
              <img
                src={intro29mobile_linha1}
                className="bp2-linha1 bp2-intro29-anima-animate-enter7"
              />
            </div>
            <div className="bp2-a25janeiro204-layout-container">
              <div className="bp2-a25janeiro204 bp2-intro29-anima-animate-enter8">
                {locale === 'en-US' ? (
                  <>
                    <span className="bp1-span1">. </span>
                    <span className="bp1-span3">{month}</span>
                    <span className="bp1-span2"> . {day} . </span>
                    <span className="bp1-span4">{year}</span>
                    <span className="bp1-span5"> .</span>
                  </>
                ) : (
                  <>
                    <span className="bp1-span1">. </span>
                    <span className="bp1-span2">{day}</span>
                    <span className="bp1-span3"> . {month} . </span>
                    <span className="bp1-span4">{year}</span>
                    <span className="bp1-span5"> .</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
